import React, { useState, useRef } from 'react';
import { translations } from './constants/translations';
import { Language } from './types';
import Header from './components/Header';
import Hero from './components/Hero';
import WhatIDo from './components/WhatIDo';
import TargetAudience from './components/TargetAudience';
import WhyMe from './components/WhyMe';
import Contact from './components/Contact';
import WhatsAppButton from './components/WhatsAppButton';
import Footer from './components/Footer';

const App: React.FC = () => {
  const [lang, setLang] = useState<Language>('pt');
  const t = translations[lang];
  
  const scrollTimeoutRef = useRef<number | null>(null);

  const toggleLanguage = () => {
    setLang(prev => (prev === 'pt' ? 'en' : 'pt'));
  };

  const handleManualSectionChange = (sectionId: string) => {
    if (scrollTimeoutRef.current) {
      window.clearTimeout(scrollTimeoutRef.current);
    }

    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="min-h-screen flex flex-col selection:bg-indigo-100 selection:text-indigo-900">
      <Header 
        lang={lang} 
        toggleLanguage={toggleLanguage} 
        t={t.nav} 
        onNavigate={handleManualSectionChange}
      />
      
      <main className="flex-grow">
        <Hero t={t.hero} onContactClick={() => handleManualSectionChange('contact')} />
        
        <div id="what-i-do" className="scroll-mt-20">
          <WhatIDo t={t.whatIDo} />
        </div>

        <div id="who-for" className="scroll-mt-20">
          <TargetAudience t={t.whoFor} />
        </div>

        <div id="why-me" className="scroll-mt-20">
          <WhyMe t={t.whyMe} />
        </div>

        <div id="contact" className="scroll-mt-20">
          <Contact t={t.contact} lang={lang} />
        </div>
      </main>

      <Footer t={t.footer} />
      <WhatsAppButton />
    </div>
  );
};

export default App;